import { Box, Typography } from "@mui/material";
import { Switch } from "@powerdiary/components-library/lib";

interface ITimeSlotToggleProps {
    generalValue: number;
    value: number;
    isMobile: boolean;
    label: string;
    isFirstRow: boolean;
    onChange: (value: number) => void;
}

export default function TimeSlotToggle({
    generalValue,
    value,
    isMobile,
    label,
    isFirstRow,
    onChange,
}: ITimeSlotToggleProps) {
    const isChecked = (generalValue & value) === value;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.checked
            ? generalValue | value // Set bit
            : generalValue & ~value; // Clear bit

        onChange(newValue);
    };

    return isMobile || isFirstRow ? (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0.5,
            }}
            data-test-id="toggle"
        >
            <Typography variant="paragraphExtraSmallSemiBold" color="text.secondary">
                {label}
            </Typography>
            <Switch
                checked={isChecked}
                onChange={handleChange}
                id={`checkbox-${value}`}
                name={`checkbox-${value}`}
                size="small"
            />
        </Box>
    ) : (
        <Switch
            checked={isChecked}
            onChange={handleChange}
            id={`checkbox-${value}`}
            name={`checkbox-${value}`}
            size="small"
        />
    );
}
